module.exports = __webpack_public_path__ + "static/dashboard-mobile-a6cc1951a23cf8aca924d590db508aa6.png";